import type {SVGProps} from 'react';
import {forwardRef} from 'react';

export const LightningBoldOutlineNewIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props} ref={ref}>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            // eslint-disable-next-line max-len
            d='M13.261 1.03468C13.6971 1.15259 14 1.54825 14 2.00003V9.00003H18C18.3581 9.00003 18.6888 9.19147 18.8671 9.50197C19.0455 9.81246 19.0442 10.1946 18.8638 10.5039L11.8638 22.5039C11.6361 22.8941 11.1751 23.0833 10.739 22.9654C10.3029 22.8475 10 22.4518 10 22V15H6C5.64193 15 5.3112 14.8086 5.13286 14.4981C4.95452 14.1876 4.9558 13.8054 5.13622 13.4962L12.1362 1.49616C12.3639 1.10592 12.8249 0.91678 13.261 1.03468ZM7.74104 13H11L12 13.0001V14V18.3011L16.259 11C14.9863 11 13 11 13 11H12V10V5.69895L7.74104 13Z'
            fill='currentColor'
        />
    </svg>
));
